"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RETURN_URL_QUERY_PARAM_KEY = exports.INVITATION_OFFER_HASH = exports.CONSULTANT_NUMBER_QUERY_PARAM_KEY = void 0;
/* istanbul ignore file -- constants file */
const CONSULTANT_NUMBER_QUERY_PARAM_KEY = exports.CONSULTANT_NUMBER_QUERY_PARAM_KEY = 'chPwdUsr';
const RETURN_URL_QUERY_PARAM_KEY = exports.RETURN_URL_QUERY_PARAM_KEY = 'returnUrl';
const INVITATION_OFFER_HASH = exports.INVITATION_OFFER_HASH = '#open-invitation-offer';
